declare global {
  interface Window {
    gtag: (...args: any[]) => void
    dataLayer: any[]
  }
}

// console.log('[PLUGIN] gtag.client.ts loaded')

export default defineNuxtPlugin(() => {
  if (!import.meta.client) return

  const config = useRuntimeConfig() // 👈 store the config
  // console.log('[GA Plugin] runtime config:', config.public) // 👈 dump everything

  const gtagId = config.public.gaId
  if (!gtagId) {
    console.warn('[GA Plugin] gaId missing from runtimeConfig')
    return
  }

  // Skip initializing gtag on tests
  if (gtagId === 'test') return

  // console.log('[GA Plugin] Loaded with ID:', gtagId)

  window.dataLayer = window.dataLayer || []
  useHead({
    script: [
      {
        src: `https://www.googletagmanager.com/gtag/js?id=${gtagId}`,
        async: true,
      },
    ],
  })

  function gtag(..._args: any[]) {
    ;(window.dataLayer as any).push(arguments)
  }
  window.gtag = gtag

  gtag('js', new Date())
  gtag('config', gtagId, {
    debug_mode: true,
    send_page_view: false,
  })
})
